/**
 * Текст ошибки для пользователя (§52, B1).
 *
 * Переводим по коду, а не показываем текст сервера: сервер один, а языков
 * десять. Текст сервера остаётся запасным — для кода, которого клиент ещё
 * не знает: показать чужой язык лучше, чем пустое место.
 */
import { i18n } from './index';
import type { ApiRequestError } from '../api/client';

export function errorText(error: unknown): string {
  if (!error || typeof error !== 'object') return i18n.t('error.INTERNAL_ERROR');

  const api = error as Partial<ApiRequestError>;
  const code = typeof api.code === 'string' ? api.code : null;
  const fallback = typeof api.message === 'string' ? api.message : i18n.t('error.INTERNAL_ERROR');

  const params = { ...(api.params ?? {}), defaultValue: fallback };

  // Уточнённый код точнее общего: «Проект не найден» против «Не найдено».
  if (api.messageCode) return i18n.t(`notice.${api.messageCode}`, params);
  if (!code) return fallback;

  return i18n.t(`error.${code}`, params);
}
